// Import utilities
import { itemsObject } from '@builder/common/utilities';

const {
	isEmpty
} = _uo.utility;

import {
	recipeHasConditions,
	getConditionsByActionId
} from '@builder/item/conditions/utilities';

/**
 * Returns an object with the actions with conditions
 *
 * @return {Object} The actions with conditions
 */
const getActionsWithConditions = () => {
	// Default response
	const actionsWithConditions = {};

	// Check if there are conditions
	if ( recipeHasConditions() ) {
		// Get all actions
		const allActions = itemsObject( 'get', {
			filter: {
				itemType: 'action',
			},
		} );

		// Iterate all actions
		Object.entries( allActions ).forEach( ( [ actionId, action ] ) => {
			// Get the conditions of this action
			const conditions = getConditionsByActionId( {
				actionId: actionId,
			} );

			// Check if it has conditions
			if ( ! isEmpty( conditions ) ) {
				// Add both the action and the condition
				actionsWithConditions[ actionId ] = {
					conditionsGroup: conditions,
					action: action,
				};
			}
		} );
	}

	return actionsWithConditions;
};

export default getActionsWithConditions;
